
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-15091.65 16849.35 12.407 12.301"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_203_25","data-name":"Symbol 203 – 25","transform":"translate(1766.326 253)","opacity":".64"}},[_c('g',{attrs:{"id":"Group_8343","data-name":"Group 8343","transform":"translate(0 1)"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3674","d":"M11.13 23.995H1.975A.973.973 0 0 1 1 23.02v-2.645a.973.973 0 0 1 .975-.975h9.155a.973.973 0 0 1 .975.975v2.645a.951.951 0 0 1-.975.975z","data-name":"Path 3674","transform":"translate(-16858.326 16583.006)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3675","d":"M1.1 8.066l1.462-6.231A1.188 1.188 0 0 1 3.606 1H9.7a1.188 1.188 0 0 1 1.044.835l1.427 6.2","data-name":"Path 3675","transform":"translate(-16858.393 16595)"}}),_c('circle',{attrs:{"id":"Ellipse_954","cx":".905","cy":".905","r":".905","data-name":"Ellipse 954","transform":"translate(-16849.529 16603.764)","fill":"#444"}})])])])
          )
        }
      }
    